export default function updateRestrictionInBasket({ props, state }) {
  const { id, restriction } = props.payload
  const { basketItems } = state.get('basket')
  Object.keys(basketItems).forEach(key => {
    const item = basketItems[key]
    if (item.id === id) {
      state.set(
        `basket.basketItems.${key}.restriction`,
        restriction ? restriction.type : null
      )
    }
  })
}



// WEBPACK FOOTER //
// ./src/modules/Socket/actions/updateRestrictionInBasket.js